import { storageLocationIdFormat } from "@redotech/redo-ids/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setFulfillmentGroupPickedQuantities = {
  name: "setFulfillmentGroupPickedQuantities" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    updates: z.array(
      z.object({
        fulfillmentOrderLineItemExternalId: z.string(),
        quantityPicked: z.number().int().min(0),
        sourceStorageLocationId: storageLocationIdFormat.schema.nullish(),
        receiveFromExternal: z.boolean().optional(),
      }),
    ),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string().nullish(),
    pickSessionItemStatuses: z
      .array(
        z.object({
          fulfillmentOrderLineItemExternalId: z.string(),
          quantityPicked: z.number(),
        }),
      )
      .nullish(),
  }),
};
